import axios from 'axios';
import { actions as apiActions } from '../actions';
const {
    apiCallFailure,
    apiCallSuccess,
    apiCallStarted,
} = apiActions;

import { actions as mapActions } from 'mapVisualizer';
const { assignMapSettings, generateMap, populateMapData } = mapActions;

import { actions as donorRollActions } from 'donorRoll';
const { assignDonorRollSettings } = donorRollActions;

import { actions as affiliationActions } from 'affiliation';
const { assignAffiliationSettings } = affiliationActions;

import { actions as leaderboardActions } from 'leaderboards';
const { assignLeaderboardSettings } = leaderboardActions;

import { actions as dashboardActions } from 'dashboards';
const { assignDashboardSettings } = dashboardActions;

import { actions as ambassadorActions } from 'ambassador';
const { assignAmbassadorSettings } = ambassadorActions;

import { actions as viewchallengeActions } from 'viewchallenge';


import { InstanceSettingsApi, ApiPollingTimeIntervalApi } from '../requests';
import { assignScoreboardTypeId } from 'app/actions';
import { buildMapObject } from '../selectors';
import { validateSettings } from '../functions';
import { watchLeaderboardData } from './leaderboards';
import { watchGetAffiliationData } from './affiliations';
import { watchGetMapData } from './maps';
import { watchGetDonorRollData } from './donorRolls';
import { watchCampaignDashboardData } from './dashboards';
import { watchGetAmbassadorData, watchAfterSocialShareRequest, watchGetChallengeData, initiateChallengeDataPolling } from './ambassador';
import { watchGetChallengeViewData } from './viewchallenge';
import { Dispatch } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { network } from '@imodules/helix';
import { initiateLeaderboardPolling } from '../sagas/leaderboards';
import { initiateDonorRollPolling } from '../sagas/donorRolls';
import { initiateAffiliationDataPolling } from '../sagas/affiliations';
import { initiateCampaignDashboardPolling } from '../sagas/dashboards';
import { initiateAmbassadorDataPolling } from '../sagas/ambassador';
import { initiateViewChallengeDataPolling } from '../sagas/viewchallenge';
import { initiateMapPolling } from '../sagas/maps';
type FetchSettingsAction = ThunkAction<void, RootState, unknown, any>;

export interface testValues {
    controlId: number,
    scoreboradType: number
}

export const getSettings = (id: number): FetchSettingsAction => {
    return async (dispatch: Dispatch<any>, getState: () => RootState) => {
        dispatch(apiCallStarted());

        try {
            const request = InstanceSettingsApi.createGetRequest(id);
            const result = await network.call(request);
            if (result.response === undefined) {
                return;
            }
            dispatch(apiCallSuccess());
            const settings = result.response.content;
            let values = settings.scoreboardTypeId;
            switch (settings.scoreboardTypeId) {
                case 5:
                case 9:
                case 13:
                    dispatch(assignLeaderboardSettings(settings as LeaderboardSettingsDto));
                    dispatch(assignScoreboardTypeId(values));
                    dispatch(initiateLeaderboardPolling());
                    break;
                case 6:
                    dispatch(assignDonorRollSettings(settings as DonorRollSettingsDto));
                    dispatch(assignScoreboardTypeId(values));
                    dispatch(initiateDonorRollPolling());
                    break;
                case 7:
                    dispatch(assignAffiliationSettings(settings as AffiliationSettingsDto));
                    dispatch(assignScoreboardTypeId(values));
                    dispatch(initiateAffiliationDataPolling());
                    break;
                case 8:
                    dispatch(assignDashboardSettings(settings as DashboardSettingsDto));
                    dispatch(assignScoreboardTypeId(values));
                    dispatch(initiateCampaignDashboardPolling());
                    break;
                case 10:
                    dispatch(assignAmbassadorSettings(settings as AmbassadorSettingsDto));
                    dispatch(assignScoreboardTypeId(values));
                    dispatch(initiateAmbassadorDataPolling());
                    dispatch(initiateChallengeDataPolling());

                    break;
                case 11:
                    dispatch(viewchallengeActions.assignChallengeSettings(settings as ChallengeSettingsDto));
                    dispatch(assignScoreboardTypeId(values));
                    dispatch(initiateViewChallengeDataPolling());
                    break;
                default:
                    const layoutSettings = settings.layoutSettings as MapLayoutSettingsOptions;
                    dispatch(assignMapSettings(settings as MapSettingsDto));
                    dispatch(assignScoreboardTypeId(values));
                    dispatch(generateMap({
                        scoreboardTypeId: settings.scoreboardTypeId,
                        customizeStates: layoutSettings.customizeStates,
                        selectedStates: layoutSettings.selectedStates,
                    }));

                    const mapObject: DataApiSettings = await buildMapObject(settings);
                    const settingsAreValid: boolean = await validateSettings(mapObject);

                    if (!settingsAreValid) {
                        dispatch(apiCallFailure('Invalid settings provided from API.'));
                        dispatch(populateMapData([]));
                    } else {
                        dispatch(initiateMapPolling());
                    }
                    break;
            }
        } catch (error: any) {
            dispatch(apiCallFailure(error.message));
        }
    };
};
export const fetchApiPollingTimeInterval = () => {
    const request = ApiPollingTimeIntervalApi.createGetRequest();
    const api = axios.get(request.url, {
        headers: {
            authorization: imod.cms.scoreboards.authHeader
        }
    });

    api.then((response: any) => {
        return response.data;
    });

    return api;
};
export const sagas = [
    watchLeaderboardData(),
    watchGetMapData(),
    watchGetDonorRollData(),
    watchGetAffiliationData(),
    watchCampaignDashboardData(),
    watchGetAmbassadorData(),
    watchAfterSocialShareRequest(),
    watchGetChallengeData(),
    watchGetChallengeViewData(),
];